export type SurveyTextUpdateMode = 'onBlur' | 'onTyping';

type SurveyDocument = {
  activeElement?: unknown;
};

type SurveyNavigator = {
  maxTouchPoints?: number;
  platform?: string;
  userAgent?: string;
  userAgentData?: {
    mobile?: boolean;
  };
};

export const isMobileSurveyBrowser = (
  surveyNavigator: SurveyNavigator | undefined = typeof navigator === 'undefined' ? undefined : navigator,
) => {
  if (surveyNavigator?.userAgentData?.mobile === true) {
    return true;
  }

  const userAgent = surveyNavigator?.userAgent ?? '';
  if (/Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(userAgent)) {
    return true;
  }

  return surveyNavigator?.platform === 'MacIntel' && (surveyNavigator.maxTouchPoints ?? 0) > 1;
};

export const shouldUseBlurSurveyTextUpdates = (
  isWebview: boolean,
  surveyNavigator?: SurveyNavigator,
) => isWebview || isMobileSurveyBrowser(surveyNavigator);

export const getSurveyTextUpdateMode = (shouldUseBlurUpdates: boolean): SurveyTextUpdateMode =>
  shouldUseBlurUpdates ? 'onBlur' : 'onTyping';

export const flushActiveSurveyTextInput = (
  shouldUseBlurUpdates: boolean,
  surveyDocument: SurveyDocument | undefined = typeof document === 'undefined' ? undefined : document,
) => {
  const activeElement = surveyDocument?.activeElement as { blur?: () => void } | null | undefined;

  if (!shouldUseBlurUpdates || typeof activeElement?.blur !== 'function') {
    return false;
  }

  activeElement.blur();
  return true;
};
